export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["对手信息"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / 账户 / 电子邮件 / 电话"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / 加密地址 / 电子邮件 / 电话"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入对手方ID、账号、电子邮件或电话。搜索将自动开始。"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户ID"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["是"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["否"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已验证"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["等待验证"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个值"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个值"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个值"])}
}